import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { ToastService } from '@app/core/services/toast/toast.service';
import type { SwiperContainer } from 'swiper/element';
import { faSearchMinus, faSearchPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-image-slide',
    templateUrl: './image-slide.component.html',
    styleUrls: ['./image-slide.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImageSlideComponent implements OnInit, AfterViewInit {
    @ViewChild('swiper', { static: true }) swiper?: ElementRef<SwiperContainer>;

    private readonly swiperNavigationStyles = [
        `
            .swiper-button-next svg,
            .swiper-button-prev svg {
                height: 25px !important;
            }
        `,
    ];

    faSearchMinus = faSearchMinus;
    faSearchPlus = faSearchPlus;
    faTimes = faTimes;
    program: any;
    image: any;
    imagesArr = [];
    position = 0;
    private hasViewInitialized = false;

    sliderOpts = {
        zoom: {
            containerClass: 'swiper-zoom-container',
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            zoomedSlideClass: 'swiper-slide-zoomed',
        },
    };

    constructor(private navParams: NavParams, private modalCtrl: ModalController, private toastService: ToastService) {}

    ngOnInit() {
        this.image = this.navParams.get('image');
        this.program = this.navParams.get('program');
        this.position = this.navParams.get('index');

        if (this.program.image.length > 0) {
            this.imagesArr = this.program.image.filter((image) => image.size === 'md' && image.Key.endsWith('.webp'));
        } else {
            // load default image?
            // this.imagesArr = this.program?.state?.img;
        }
    }

    ngAfterViewInit() {
        this.hasViewInitialized = true;
        this.setupSwiper();
    }

    setupSwiper() {
        if (!this.hasViewInitialized || !this.swiper?.nativeElement) {
            return;
        }

        setTimeout(() => {
            const swiperEl = this.swiper?.nativeElement;
            if (!swiperEl) {
                return;
            }

            swiperEl.loop = this.imagesArr.length > 1;
            swiperEl.injectStyles = this.swiperNavigationStyles;

            if (swiperEl.swiper) {
                swiperEl.swiper.params.loop = swiperEl.loop;
                swiperEl.swiper.update();
                return;
            }

            swiperEl.initialize();
        });
    }

    showToasterMessage(message: string) {
        this.toastService.create({
            message: message,
            duration: 3000,
            position: 'top',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    },
                },
            ],
            color: 'danger',
        });
    }

    zoom(zoomIn: boolean) {
        if (zoomIn) {
            this.swiper?.nativeElement.swiper?.zoom.in();
        } else {
            this.swiper?.nativeElement.swiper?.zoom.out();
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
